import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from '../../hooks/useTranslation';
import { Errors } from '../../locales/types';
import { HttpStatus } from '../../types/enums/http-status.enum';
import { Box } from '../ui/Box/Box';
import { Button } from '../ui/Button/Button';
import style from './Error500.module.scss';

export const Error500 = () => {
  const { goBack } = useHistory();
  const { t } = useTranslation<Errors>('errors');

  return (
    <Box className={style.container}>
      <h1>{HttpStatus.INTERNAL_SERVER_ERROR}</h1>
      <p className={style.info}>{t('error500text')}</p>
      <Button type='primary' onClick={() => goBack()}>{t('goBack')}</Button>
    </Box>
  );
};
